import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { toast } from 'sonner';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { api, ApiError } from '@/lib/api';

export const Route = createFileRoute('/_authenticated/sites/new')({
  component: NewSiteModal,
});

function NewSiteModal() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const [name, setName] = useState('');
  const [domain, setDomain] = useState('');

  const create = useMutation({
    mutationFn: () => api.sites.create({ name, domain }),
    onSuccess: ({ site }) => {
      toast.success(`Site "${site.name}" created`);
      qc.invalidateQueries({ queryKey: ['sites'] });
      navigate({ to: '/sites/$siteId', params: { siteId: site.id } });
    },
    onError: (err) => {
      if (err instanceof ApiError) toast.error(err.message || 'Failed to create site');
      else toast.error('Failed to create site');
    },
  });

  return (
    <Dialog open onOpenChange={(open) => !open && navigate({ to: '/sites' })}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Add a new site</DialogTitle>
          <DialogDescription>
            Track user behavior for any landing page or website. You'll get an install snippet on the next screen.
          </DialogDescription>
        </DialogHeader>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            create.mutate();
          }}
          className="space-y-4 py-2"
        >
          <div className="space-y-2">
            <Label htmlFor="name">Site name</Label>
            <Input id="name" placeholder="Eiko Gakuen Landing" required value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="space-y-2">
            <Label htmlFor="domain">Domain</Label>
            <Input id="domain" placeholder="eikogakuen.vn" required value={domain} onChange={(e) => setDomain(e.target.value)} />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => navigate({ to: '/sites' })}>
              Cancel
            </Button>
            <Button type="submit" disabled={create.isPending}>
              {create.isPending ? 'Creating…' : 'Create site'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
